import React from "react";
const helpcanvas = {
  display: 'grid',
  gridTemplateColumns: '2fr 3fr 5fr',
  gridTemplateRows: 'min-content 1fr',
  backgroundColor: "#f2f2f2",
  height: '100vh',
  width: '100%',
  rowGap: '24px',
  columnGap: '14px',
  padding: '0 0 14px 0',
};

const helptitle = {
  color: "#222",
  backgroundColor: "#f2f2f2",
  padding: "2px",
  fontFamily: "Arial",
  fontSize: "13px",
};

const helpimg = {
    color: "#222",
    backgroundColor: "#f2f2f2",
    padding: "2px",
    fontFamily: "Arial",
  };

const UIDSHistory = {
    name: 'DS in Progress',
    imageUrl: '../../images/DSHistory.png',
    imageSize: "99%",
    bradius: 20,
  };


export const DSHistory = () => {
  return (
    <div style={helpcanvas}>
      <div
      style={{ marginLeft: "310px" }}
      ></div>
      <div style={helptitle}><b>Data Scan History</b><br/><br/>
      Any existing data scans that have either been completed or cancelled are shown in the data scan history table.<br/><br/>
      Select a scan type from the options provided to view all the scans under that category. As an example, 
      the scan type selected in this screenshot is “Local/ CIFS-SMB”.<br/><br/>
      By default, the scan history table will show 10 results. However, depending on the volume of scans you have 
      performed previously, there are additional features allowing you to search or apply filters to find the 
      information you need quickly.<br/><br/>
      <ul style={{marginLeft: '4em'}}>
      <li>No. of scans to display - click the numeric 10 at the top right and select a different value for the number of scans to display </li>      
      <li>Search box - Type the name of the specific scan you are looking for in the search box to find it quickly </li>
      </ul><br/>
      Within this display, you can view scan names, see who issued each scan, view start and end dates and the 
      percentage of data scanned that was found to be sensitive. <br/><br/>
      You can also create an <b>Action</b> by clicking on the three dots in the Action column. The Action icons allow 
      you to either delete a scan or begin building a mitigation plan. <br/><br/>Please note that the delete scan 
      icon is not shown when there is a mitigation plan in place for files in this scan. In addition, the 
      create a mitigation plan option is not shown when there are zero sensitive files or if all sensitive 
      files are already in a pre-existing plan. <br/><br/>
      <b>View scan details:</b> You can click on any of the scan names to view a summary of the scan performance. 
      </div>
      <div style={helpimg}>
      <img
        src={UIDSHistory.imageUrl}
        alt={'Image of ' + UIDSHistory.name}
        style={{
          width: UIDSHistory.imageSize,
          borderRadius: UIDSHistory.bradius,
        }}
      />
      </div>
    </div>
  );
};

